/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

/**
 * This function checks that an element is interactive and of a type that doesn't disrupt grid navigation.
 * @param element the element to check
 * @returns true if the element is an interactive element that doesn't disrupt grid navigation
 */
export const isValidInteractiveElement = (element: Element): boolean => {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  const interactiveTags = new Set(['A', 'BUTTON', 'DETAILS']);
  const interactiveInputTypes = new Set([
    'checkbox',
    'radio',
    'submit',
    'reset',
  ]);

  if (interactiveTags.has(element.tagName)) {
    return true;
  }

  if (element.tagName === 'INPUT') {
    const inputType = (element as HTMLInputElement).type;
    return interactiveInputTypes.has(inputType);
  }

  return false;
};
